import React, { useState, useEffect } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { api } from '../api/client'

export default function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token') || ''
  const [status, setStatus] = useState('loading') // loading | success | error
  const [error, setError] = useState('')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setError('Kein Aktivierungslink. Bitte den Link aus der E-Mail verwenden.')
      return
    }
    api.post('/auth/verify-email', { token })
      .then(() => {
        setStatus('success')
        setTimeout(() => navigate('/login', { state: { message: 'E-Mail bestätigt. Sie können sich jetzt anmelden.' } }), 3000)
      })
      .catch((err) => {
        setStatus('error')
        const msg = err?.response?.data?.detail || err?.message || ''
        if (typeof msg === 'string' && (msg.includes('Ungültiger') || msg.includes('abgelaufen'))) {
          setError('Link ungültig oder abgelaufen. Bitte erneut registrieren oder den Link erneut anfordern.')
        } else {
          setError(typeof msg === 'string' ? msg : 'Aktivierung fehlgeschlagen.')
        }
      })
  }, [token, navigate])

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
        <div className="card-glass w-full max-w-md p-6 sm:p-8">
          <div className="flex justify-center" aria-hidden>
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500 to-pink-500 text-2xl font-bold shadow-glow">◇</div>
          </div>
          <h1 className="mt-6 text-center text-2xl font-bold text-white">
            <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">Konto aktivieren</span>
          </h1>
          <p className="mt-4 text-center text-white/80">Bitte warten…</p>
        </div>
      </div>
    )
  }

  if (status === 'success') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
        <div className="card-glass w-full max-w-md p-6 sm:p-8">
          <h1 className="text-center text-xl font-bold text-white">E-Mail bestätigt</h1>
          <p className="mt-4 text-center text-white/80">Ihr Konto ist aktiv. Sie werden zur Anmeldung weitergeleitet…</p>
          <p className="mt-6 text-center">
            <Link to="/login" className="text-violet-300 hover:underline">Jetzt anmelden</Link>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
      <div className="card-glass w-full max-w-md p-6 sm:p-8">
        <h1 className="text-center text-xl font-bold text-white">Aktivierung fehlgeschlagen</h1>
        <p className="mt-4 text-center text-white/80">{error}</p>
        <p className="mt-6 text-center">
          <Link to="/login" className="text-violet-300 hover:underline">Anmelden</Link>
          {' · '}
          <Link to="/register" className="text-violet-300 hover:underline">Registrieren</Link>
        </p>
      </div>
    </div>
  )
}
